module.exports = __webpack_public_path__ + "img/normal_delete.eb6c2787.svg";